import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  bannerName: Yup.string().required('Required'),
})
